import { postFinalizarAfericao } from '../offline/api';

export async function finalizarAfericao(afericaoId) {
  try {
    await postFinalizarAfericao(afericaoId);
  } catch (error) {
    console.error('Erro ao finalizar aferição:', error);
    throw new Error('Erro ao finalizar aferição. Tente novamente.');
  }
}

